import { Reducer } from 'redux';
import { toast } from 'react-toastify';
import { CoreActionTypes, CoreState } from './types';
import { StudentActionTypes } from '../types';

const initialState: CoreState = {
  student_id: '',
  student_number: '',
  email: '',
  university: '',
  createdAt: 0,
  updatedAt: 0,
  infoProcessingConsent: false,
  legalAdviseDisclaimer: false,
  casIssued: false,
};
// SHLD-970
// export const getUpdatedStudentStatus = (
//   newStatus: VisaStatus,
//   oldStatus: Status
// ): Status => {
//   let updatedCoreStatus = oldStatus;

//   switch (newStatus) {
//     case VisaStatus.INTENDS_TO_DEFER:
//       updatedCoreStatus = Status.DEFERRED;
//       break;
//     case VisaStatus.INTENDS_TO_WITHDRAW:
//       updatedCoreStatus = Status.CLOSED_LOST;
//       break;
//     case VisaStatus.VISA_RECEIVED:
//       updatedCoreStatus = Status.VISA_ISSUED;
//       break;
//     case VisaStatus.VISA_REFUSAL:
//       updatedCoreStatus = Status.VISA_REFUSED;
//       break;
//   }
//   return updatedCoreStatus;
// };

const reducer: Reducer<CoreState> = (state = initialState, action) => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return { ...initialState, ...action.payload.student.core };
    case StudentActionTypes.SAVE_PERSONAL_INFO_SUCCESS:
    case StudentActionTypes.SAVE_HISTORY_SUCCESS:
    case StudentActionTypes.SAVE_CONSENTS_SUCCESS:
    case StudentActionTypes.SAVE_PRE_CAS_INTERVIEW_SUCCESS:
    case StudentActionTypes.SAVE_VISA_PREP_FORM_SUCCESS:
    case StudentActionTypes.UPDATE_CONFLICT_SUCCESS:
    case StudentActionTypes.UPDATE_OFFER_EVIDENCE_SUCCESS:
    case CoreActionTypes.UPDATE_ASSIGNED_AGENTS_SUCCESS:
      if (action.payload.core) {
        return { ...initialState, ...action.payload.core };
      }
      return state;
    case CoreActionTypes.UPDATE_LEGAL_ADVISE_DISCLAIMER:
      return {
        ...state,
        legalAdviseDisclaimer: action.payload,
      };
    case CoreActionTypes.UPDATE_INFO_PROCESSING:
      return {
        ...state,
        ...action.payload.config?.Checklist?.defaultOverrides?.core,
        infoProcessingConsent: action.payload.value,
      };
    case CoreActionTypes.UPDATE_ASSIGNED_AGENTS: {
      return {
        ...state,
        assignedAgents: action.payload.assignedAgents,
        lockAgent: action.payload.lockAgent,
      };
    }
    case StudentActionTypes.UPDATE_UNI_STUDENT_NUMBER:
      return {
        ...state,
        uniPartnerId: action.payload.uniStudentNumber,
      };
    case StudentActionTypes.UPDATE_STATUS:
      return {
        ...state,
        status: action.payload.status,
      };
    case StudentActionTypes.UPDATE_CORE:
      return {
        ...action.payload.data,
      };
    case StudentActionTypes.CHANGE_STUDENT_NO_SUCCESS: {
      toast.success(`Changed student number to ${action.payload} successfully!`);
      return state;
    }
    case StudentActionTypes.CHANGE_STUDENT_NO_FAILURE: {
      toast.error(`Failed to change student number: ${action.payload}`);
      return state;
    }
    case StudentActionTypes.DELETE_STUDENT_SUCCESS: {
      toast.success(`Deleted student (${action.payload}) successfully!`);
      return state;
    }
    case StudentActionTypes.DELETE_STUDENT_FAILURE: {
      toast.error(`Failed to delete student: ${action.payload}`);
      return state;
    }
    case StudentActionTypes.REMOVE_IMPORT_HASH_SUCCESS: {
      toast.success('Student import hash successfully removed!');
      return state;
    }
    case StudentActionTypes.REMOVE_IMPORT_HASH_FAILURE: {
      toast.error(action.payload);
      return state;
    }

    default:
      return state;
  }
};

export { reducer as coreReducer };
